import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getWelcomeCourses(params = {}) {
  try {
    const queryParams = new URLSearchParams(params).toString();
    const response = await axios.get(`${import.meta.env.VITE_APP_API_URL}welcome-courses${queryParams ? `?${queryParams}` : ''}`);
    return response.data;

  } catch (error) {
    console.error('Error al obtener los cursos de bienvenida', error);
  }
}